export default __webpack_public_path__ + "static/media/map_skew.d315e5dd.png";